<template>
  <div class="w-full flex flex-col gap-5">
    <!-- WATCH VIDEO -->
    <!-- <a class="w-full flex items-center gap-3 p-1.5 bg-neutral-25 transition-colors hover:bg-neutral-50" 
    href="" target="_blank" style="border-radius: 14px;">
      <div class="claude-setup-thumbnail flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M16.1838 8.72367L7.78824 3.53819C6.78891 2.92095 5.5 3.63981 5.5 4.81439V15.1854C5.5 16.3599 6.7889 17.0787 7.78823 16.4616L16.1838 11.2761C17.1328 10.6899 17.1328 9.30979 16.1838 8.72367Z" fill="white"/>
        </svg>
      </div>
      <div class="flex-grow flex flex-col">
        <BaseText type="label" size="sm" class="text-text-muted">
          Watch Video
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal">
          Learn how to connect Foreplay to Claude.
        </BaseText>
      </div>
    </a> -->
    <!-- TUTORIAL STEPS -->
    <div class="steps-container">
      <BaseText type="label" size="sm" class="step-number">
        1
      </BaseText>
      <div class="w-full flex flex-col">
        <BaseText type="label" size="sm" class="text-text-muted">
          Open Claude Settings
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal mt-1">
          Launch the app or open claude.ai and go to
        </BaseText>
        <a class="w-max flex items-center gap-1 pl-2.5 py-1.5 pr-2 mt-2 rounded-lg border border-border-normal transition-colors duration-100 hover:border-border-hover"
        href="https://claude.ai/customize/connectors" target="_blank">
          <BaseText type="body" size="sm" class="text-text-muted">
            Settings
          </BaseText>
          <ChevronIcon className="text-icon-normal transform -rotate-90" />
          <BaseText type="label" size="sm" class="text-text-muted">
            Connectors
          </BaseText>
          <OpenExternalIcon small class="text-icon-normal" />
        </a>
      </div>
      <BaseText type="label" size="sm" class="step-number">
        2
      </BaseText>
      <div class="w-full flex flex-col">
        <BaseText type="label" size="sm" class="text-text-muted">
          Add a custom connector
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal mt-1">
          Name it "Foreplay" and copy/paste the URL:
        </BaseText>
        <CopiableLink link="https://public.api.foreplay.co/mcp" class="mt-2" />
      </div>
      <BaseText type="label" size="sm" class="step-number">
        3
      </BaseText>
      <div class="w-full flex flex-col">
        <BaseText type="label" size="sm" class="text-text-muted">
          Connect and sign in
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal mt-1" style="width: 440px;">
          Click Add → Connect, sign in with your Foreplay account.  You're all set, now Claude has the power of Foreplay.
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
import OpenExternalIcon from '../../globals/Icons/OpenExternalIcon.vue'
import ChevronIcon from '../../globals/Icons/ChevronIcon.vue'

import CopiableLink from './CopiableLink.vue'

export default {
  name: 'ClaudeMCPSetup',
  components: {
    OpenExternalIcon,
    ChevronIcon,
    CopiableLink
  }
}
</script>

<style scoped>
.claude-setup-thumbnail {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 48px;
  border-radius: 8px;
  background: 
    url('https://publicassets.foreplay.co/mcp-tutorial-thumbnails/claude-mcp-tutorial-thumbnail.png') 
  lightgray -5.728px 0px / 115.073% 100% no-repeat;
}
</style>